import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';

/**
 * Vehicle utilization rate KPI DTO
 */
@CaslSubject(AppSubjectEnum.VEHICLE)
export class KpiVehicleUtilizationRateDto {
	periodDays!: number;
	rentalDays!: number;
	maintenanceDays!: number;
	outOfServiceDays!: number;
	totalUtilizedDays!: number;
	totalDowntimeDays!: number;
	utilizationRate!: number;
}
